import {
    AppUserStatus,
    type DataSourceAbstract,
    type FilterCommonCondition,
    type QuickFilterConfig,
    type VariableADTvalue,
    VariableType
} from '@lighthouse/core'
import { find, intersection } from 'rambda'

import { DEFAULT_VALUE_VARIABLE, getInitQuickFilter } from '../components'
import type { UserOption } from '../types'
import { getVariableFieldId } from './condition'
import { isIdsValue } from './helper'

interface getQuickFilterRuleParams {
    quickFiltersCache: FilterCommonCondition[]
    quickFilter: QuickFilterConfig
    dataSource: DataSourceAbstract
    personOptions: UserOption[]
}

export const getQuickFilterRule = ({ quickFiltersCache, quickFilter, dataSource, personOptions }: getQuickFilterRuleParams) => {
    const rules = [...quickFiltersCache]
    if (quickFilter.mode === 'disable') {
        return []
    }
    return (
        quickFilter.fieldIds?.reduce<FilterCommonCondition[]>((acc, fieldId) => {
            const rule = find(rule => getVariableFieldId(rule.idVariable) === fieldId, rules)
            if (!dataSource) {
                return acc
            }
            const field = dataSource.schema[fieldId]
            if (!field) {
                return acc
            }
            if (rule && field.type === 'select') {
                const { options } = field.select
                const labels = options.map(item => item.label)
                const newParamList: VariableADTvalue[] = rule?.paramList?.map(param => {
                    if (param.type === VariableType.VALUE) {
                        const value = param.valueVariable?.value
                        if (isIdsValue(value)) {
                            const newValue = intersection(labels, value)
                            return {
                                type: VariableType.VALUE,
                                valueVariable: {
                                    value: newValue,
                                    type: 'select'
                                }
                            }
                        }
                    }
                    return param
                }) || [DEFAULT_VALUE_VARIABLE]
                const r: FilterCommonCondition = { ...rule, paramList: newParamList }
                const newRule = getInitQuickFilter(field, quickFilter.mode, r)
                acc.push(newRule)
                return acc
            }
            if (rule && field.type === 'person') {
                const userIds = personOptions.reduce<string[]>(
                    (prev, cur) => {
                        if (cur.status === AppUserStatus.DEPART) {
                            return prev
                        }
                        prev.push(cur.id)
                        return prev
                    },
                    ['{currentUserId}']
                )
                const newParamList: VariableADTvalue[] = rule?.paramList?.map(param => {
                    if (param.type === VariableType.VALUE) {
                        const value = param.valueVariable?.value
                        if (isIdsValue(value)) {
                            const newValue = intersection(userIds, value)
                            return {
                                type: VariableType.VALUE,
                                valueVariable: {
                                    value: newValue,
                                    type: 'person'
                                }
                            }
                        }
                    }
                    return param
                }) || [DEFAULT_VALUE_VARIABLE]
                const r: FilterCommonCondition = { ...rule, paramList: newParamList }
                const newRule = getInitQuickFilter(field, quickFilter.mode, r)
                acc.push(newRule)
                return acc
            }
            const newRule = getInitQuickFilter(field, quickFilter.mode, rule)
            acc.push(newRule)
            return acc
        }, []) || []
    )
}
